// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1CCc1","loaderWhite":"Loader_loaderWhite__FQrWr","loader-white":"Loader_loader-white__a26vJ"};